import { Controller } from '@hotwired/stimulus';

/** Toggle product admin form between on-site sales and legacy external checkout. */
export default class extends Controller {
  static targets = [
    'modeInput',
    'onSitePanel',
    'legacyPanel',
    'onSiteDeliverableField',
    'legacyCheckoutField',
    'legacyCouponField',
    'internalOfferField',
    'externalField',
    'onSiteRetailPriceField',
    'legacyRetailPriceField',
    'urlFieldContainer',
    'gateUrlSlot',
    'deliverableUrlSlot',
  ];

  connect() {
    this.syncFromInputs();
  }

  modeChanged(event) {
    this.applyMode(event.target.value);
  }

  syncFromInputs() {
    const mode = this.hasModeInputTarget
      ? Array.from(this.modeInputTargets).find((input) => input.checked)?.value
      : 'on_site';
    this.applyMode(mode || 'on_site');
  }

  applyMode(mode) {
    const onSite = mode === 'on_site';

    this.togglePanel(this.onSitePanelTargets, onSite);
    this.togglePanel(this.legacyPanelTargets, !onSite);

    if (this.hasOnSiteDeliverableFieldTarget) {
      this.onSiteDeliverableFieldTarget.hidden = !onSite;
    }

    if (this.hasLegacyCheckoutFieldTarget) {
      this.legacyCheckoutFieldTarget.hidden = onSite;
    }

    if (this.hasLegacyCouponFieldTarget) {
      this.legacyCouponFieldTarget.hidden = onSite;
    }

    if (this.hasInternalOfferFieldTarget) {
      this.internalOfferFieldTarget.value = onSite ? '1' : '0';
    }

    if (this.hasExternalFieldTarget) {
      this.externalFieldTarget.value = onSite ? '0' : '1';
    }

    if (this.hasOnSiteRetailPriceFieldTarget) {
      this.onSiteRetailPriceFieldTarget.disabled = !onSite;
    }

    if (this.hasLegacyRetailPriceFieldTarget) {
      this.legacyRetailPriceFieldTarget.disabled = onSite;
    }

    this.placeUrlField(onSite);
  }

  placeUrlField(onSite) {
    if (!this.hasUrlFieldContainerTarget) return;

    const slot = onSite
      ? (this.hasDeliverableUrlSlotTarget ? this.deliverableUrlSlotTarget : null)
      : (this.hasGateUrlSlotTarget ? this.gateUrlSlotTarget : null);

    if (slot) {
      slot.appendChild(this.urlFieldContainerTarget);
    }

    this.urlFieldContainerTarget.classList.toggle('products-editor__primary-deliverable', onSite);
  }

  togglePanel(elements, visible) {
    if (!elements) return;

    elements.forEach((el) => {
      el.hidden = !visible;
      el.querySelectorAll('input, textarea, select, button').forEach((field) => {
        if (field.type === 'radio' && field.name === 'commerce_mode_ui') return;
        if (field.dataset.productCommerceModeTarget === 'legacyRetailPriceField') return;
        if (field.dataset.productCommerceModeTarget === 'onSiteRetailPriceField') return;
        field.disabled = !visible;
      });
    });
  }
}
